import store from '@/store';
import CalculateFMCService from '@/services/DataProcess/CalculateFMCService'
import { ParseHgFarmerResult } from './utils'

import communicationService from '@/services/PostMessageCommunation/CommunicationService';
import dataKeys from '@/services/PostMessageCommunation/enums/DataKeys';

import { getTranslationPop } from '@/services/Base/TranslationUtils';

const DataWatcherService = {
  init() {
    if (!store.state.kit.deepAncestryCoordinate) {
      return;
    }
    const resolveSource = CalculateFMCService.codeDataToArray(store.state.kit.deepAncestryCoordinate);
    if (resolveSource.isSuccess) {
      CalculateFMCService.onSetTarget(resolveSource.result);
    }

    this.runHgFarmerResult();
  },

  async runHgFarmerResult() {
    try {
      const sourceDataResult = await store.dispatch('hgFarmerSourceData/fetchHgFarmerSourceData');
      if (!sourceDataResult) {
        return;
      }
      
      const resolveSource = CalculateFMCService.codeDataToArray(sourceDataResult.sourceData);
      if (resolveSource.isSuccess) {
        CalculateFMCService.onSetSource(resolveSource.result);
      }

      const calculatedResult = await this.getCurrentResult(sourceDataResult.version);
      
      const parsedCalculatedResult = ParseHgFarmerResult(calculatedResult);
  
      store.commit('hgFarmerResult/setResults', parsedCalculatedResult);

      const groupedSourceCodes = parsedCalculatedResult.resultList.map(item => item.resultName);
      const uiDetailDataResult = await store.dispatch('hgFarmerResult/fetchHgFarmerDetails', groupedSourceCodes);
      if (!uiDetailDataResult) {
        return;
      }
      
      uiDetailDataResult.forEach(geoItem => {
        /* eslint-disable */
        let isFoundData = false;
        geoItem.title = 'Map Title Not Found';
        parsedCalculatedResult.resultList.forEach(resultItem => {
          resultItem.title = getTranslationPop(store, resultItem.resultName, 'title', resultItem.resultName.replaceAll('*', ' '));
          if (resultItem.resultName === geoItem.sourceCode) {
            resultItem.color = geoItem.color;
            resultItem.logoUrl = geoItem.logoUrl;
            resultItem.id = geoItem.id;
            resultItem.sourceCode = geoItem.sourceCode;

            geoItem.title = resultItem.title;
            geoItem.ancestryValue = resultItem.resultValue.toFixed(1);

            isFoundData = true;
          }
        });

        if (isFoundData === false) {
          geoItem.ancestryValue = 0;
          geoItem.color = '#b8b8b8';
        }
      });
      
      store.commit('hgFarmerResult/setUiResults', parsedCalculatedResult);
      if (parsedCalculatedResult.resultList[0]) {
        store.dispatch('hgFarmerResult/fetchHgFarmerDetail', parsedCalculatedResult.resultList[0].id);
      }
    } catch (error) {
      console.error('Error handling specific state change:', error);
    }
  },

  async getCurrentResult(sourceDataVersion) {
    let resultData = null;
    const requestParams = {
      kit_id: '',
    };

    const response = await communicationService.requestData({ key: dataKeys.GET_HGFARMER_RESULT, value: requestParams});
    
    if(response.version !== sourceDataVersion || !response.result_data) {
      response.result_data = CalculateFMCService.runABAlgorithm();
      communicationService.sendDataToParent({ 
        key: dataKeys.SAVE_HGFARMER_RESULT, 
        value: { params: requestParams, result_data: JSON.stringify(response.result_data), version: sourceDataVersion }
      });

      resultData = response.result_data;
    } else {
      resultData = JSON.parse(response.result_data);
    }
    return resultData;
  },
};

export default DataWatcherService;
